import pvqPassportModelValidator from './passport';

export default pvqPassportModelValidator;
